export function getDescendantProperty(object, path) {
    const pathParts = path.split(/[.[]['"]?/);
    let property = object;
    while (pathParts.length && property) {
        property = property[pathParts.shift().replace(/['"]?]$/, '')];
    }

    if(property === undefined) {
        property = "Not available";
    }

    return property;

}